export default class titleNavigation {
    /**
     * initialize the title navigation on desktop
     */
    constructor(module) {
        this.module = module;
        this.count = 0;
        if (document.body.offsetWidth < 1021) {
            this.removeTitleNavigation();
        } else {
            this.initTitleNavigation();
        }
    }

    /**
     * add the navigation buttons to the container and 
     * initialize the listener
     */
    initTitleNavigation() {
        if (this.module.querySelector('.vl-related__tile').length <= 5) { return; }
        const wrapper = this.module.querySelector('.title-container');
        if (wrapper.classList.contains('title-navigation-active')) { return; }

        const previousButton = `<span class="nav-button previous disabled"></span>`;
        const nextButton = `<span class="nav-button next"></span>`;
        wrapper.insertAdjacentHTML('beforebegin', previousButton);
        wrapper.insertAdjacentHTML('afterend', nextButton);

        wrapper.classList.add('title-navigation-active')

        this.navigationListener();
    }

    /**
     * event listeners on the navigation buttons
     */
    navigationListener() {
        const prevButton = this.module.querySelector('.nav-button.previous');
        const nextButton = this.module.querySelector('.nav-button.next');

        prevButton.addEventListener('click', () => { this.moveCarouselSlider(false); })
        nextButton.addEventListener('click', () => { this.moveCarouselSlider(); })
    }

    /**
     * move the carousel over one full width
     */
    moveCarouselSlider(next = true) {
        next === true ? this.count++ : this.count -= 1;
        this.showAndHideNavigation();

        // width the padding in place, the middle between the wrapper and the container
        // needs to be taken as the amount to move the slider
        const sliderWidth = this.module.querySelector('.et_pb_rtl_titles').offsetWidth;
        const titleContainer = this.module.querySelector('.title-container').offsetWidth;
        const translateWidth = (sliderWidth + titleContainer) / 2
        const translateVal = this.count * -1 * translateWidth;

        this.module.querySelector('.title-wrapper').style.transform = `translateX(${translateVal}px)`;
    }

    /**
     * remove the class and the navigation buttons
     */
    removeTitleNavigation() {
        const wrapper = this.module.querySelector('.title-container');
        wrapper.classList.remove('title-navigation-active');
        const navButtons = this.module.querySelectorAll('.nav-button');
        for (const button of navButtons) {
            button.remove();
        }
    }

    /**
     * hide the previous button when carousel is at the beginning,
     * hide the next button when the last titles are shown
     */
    showAndHideNavigation() {
        const prevButton = this.module.querySelector('.nav-button.previous');
        const nextButton = this.module.querySelector('.nav-button.next');
        const tileSections = Math.ceil(this.module.querySelectorAll('.vl-related__tile').length / 5);

        if (this.count == 0) {
            prevButton.classList.add('disabled');
            nextButton.classList.remove('disabled');
        }

        if (this.count >= tileSections -1) {
            prevButton.classList.remove('disabled');
            nextButton.classList.add('disabled');
        }
    }
}